module.exports = __webpack_public_path__ + "static/media/ke.9eb9bde6.svg";